import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=094292dc&scoped=true&"
import script from "./Jitsi.vue?vue&type=script&lang=js&"
export * from "./Jitsi.vue?vue&type=script&lang=js&"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=094292dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094292dc",
  null
  
)

export default component.exports